export default __webpack_public_path__ + "static/media/cp_geo_py.c9084660.svg";